var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.5,
    stroke: "#E5E7DF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10084_163368",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10084_163368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6642 17.5416H15.7592C15.6032 17.5416 15.4725 17.4901 15.3671 17.387C15.2617 17.2839 15.209 17.1563 15.209 17.0041C15.209 16.8517 15.2617 16.7227 15.3671 16.617C15.4725 16.5112 15.6032 16.4583 15.7592 16.4583H18.6642L17.6657 15.431C17.552 15.321 17.4961 15.1981 17.4979 15.0624C17.4997 14.9267 17.5552 14.8039 17.6642 14.6939C17.7732 14.5839 17.9018 14.5289 18.0498 14.5289C18.1977 14.5289 18.3249 14.5823 18.4313 14.6893L20.2479 16.5397C20.3791 16.6735 20.4446 16.8269 20.4446 16.9999C20.4446 17.173 20.3791 17.3264 20.2479 17.4601L18.4313 19.3105C18.3249 19.4175 18.1977 19.471 18.0498 19.471C17.9018 19.471 17.7732 19.416 17.6642 19.306C17.5552 19.196 17.4997 19.0731 17.4979 18.9374C17.4961 18.8017 17.552 18.6789 17.6657 18.5689L18.6642 17.5416ZM8.41253 17.2916L6.78815 18.916C6.69482 19.0093 6.57496 19.0309 6.42857 18.9808C6.28218 18.9308 6.20898 18.8356 6.20898 18.6953V8.55638C6.20898 8.17818 6.34023 7.85895 6.60273 7.59867C6.86523 7.33839 7.18086 7.20825 7.54961 7.20825H16.4586C16.8272 7.20825 17.1416 7.33943 17.4019 7.60179C17.6622 7.86416 17.7923 8.17957 17.7923 8.54804V11.4166C17.7923 11.5701 17.7408 11.6987 17.6377 11.8026C17.5347 11.9064 17.407 11.9583 17.2548 11.9583C17.1025 11.9583 16.9734 11.9064 16.8677 11.8026C16.7619 11.6987 16.709 11.5701 16.709 11.4166V8.54804C16.709 8.47318 16.685 8.41172 16.6369 8.36367C16.5888 8.31561 16.5274 8.29159 16.4525 8.29159H7.54878C7.47391 8.29159 7.41246 8.31561 7.3644 8.36367C7.31635 8.41172 7.29232 8.47318 7.29232 8.54804V16.2083H12.459C12.6125 16.2083 12.7411 16.2598 12.845 16.3628C12.9488 16.4659 13.0007 16.5935 13.0007 16.7458C13.0007 16.8981 12.9488 17.0271 12.845 17.1328C12.7411 17.2387 12.6125 17.2916 12.459 17.2916H8.41253Z",
    fill: "#EE4F4F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatOpen);
export default __webpack_public_path__ + "static/media/chat-open.6236d75bf8c0cb7319ed67f8a50bef34.svg";
export { ForwardRef as ReactComponent };